import { render } from "./CompetitionsCU.vue?vue&type=template&id=12cc694a&scoped=true"
import script from "./CompetitionsCU.vue?vue&type=script&lang=js"
export * from "./CompetitionsCU.vue?vue&type=script&lang=js"

import "./CompetitionsCU.vue?vue&type=style&index=0&id=12cc694a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cc694a"]])

export default __exports__